import { createStyles, makeStyles } from '@material-ui/core'
import colors from '../../../../../shared/style/colors'

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'relative',
      padding: '1.25rem',
      textAlign: 'left',
      lineHeight: 'initial'
    },
    line: {
      borderBottom: 'solid 0.0625rem #afadad'
    },
    arrow: {
      verticalAlign: 'middle',
      height: '100%',
      position: 'absolute',
      fontSize: '0.8125rem',
      top: '0',
      right: '2rem'
    },
    subItemWrapper: {
      display: 'flex',
      flexDirection: 'column',
      color: colors.darkGrey,
      padding: '0 10px',
      '& span': {
        lineHeight: 2,
        padding: '0 10px 15px'
      }
    },
    open: {
      transform: 'rotate(90deg)'
    }
  })
)
